import { RestaurantTipsSharingListFull } from "@/screens/restaurants/details/restaurant.tipssharing.list";
import { Stack, useLocalSearchParams } from "expo-router";

export default function FullList() {
  const { orgId } = useLocalSearchParams<{ orgId: string }>();

  return (
    <>
      <Stack.Screen options={{ title: "Tips sharing scheme" }} />
      <RestaurantTipsSharingListFull organizationId={orgId} />
    </>
  );
}
